import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getSkillsAndConcepts } from "../lib/requestFunctions";

export function useSkillsAndConcepts(
    selectedClass: string | undefined,
    selectedSubject: string | undefined,
) {
    const [skillsAndConcepts, setSkillsAndConcepts] = useState<any[]>([]);

    const {
        status: skillsAndConceptsStatus,
        fetchStatus: skillsAndConceptsFetchStatus,
        data: skillsAndConceptsData,
    } = useQuery({
        queryKey: ["skillsAndConcepts", selectedClass, selectedSubject],
        queryFn: () =>
            getSkillsAndConcepts(
                selectedClass ? [parseInt(selectedClass)] : [],
                selectedSubject ? [parseInt(selectedSubject)] : [],
            ),
        // The query will not execute until the userId exists
        enabled: !!selectedClass && !!selectedSubject,
    });

    return {
        skillsAndConcepts,
        setSkillsAndConcepts,
        skillsAndConceptsData,
        skillsAndConceptsStatus,
        skillsAndConceptsFetchStatus,
        skillsAndConceptsError: skillsAndConceptsStatus === 'error',
    }
}